"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var lodash_1 = require("lodash");
var feature_detector_1 = tslib_1.__importDefault(require("../../utils/feature-detector"));
var text_overflow_clamp_1 = tslib_1.__importDefault(require("../../utils/text-overflow-clamp"));
var clamp_text_scss_1 = tslib_1.__importDefault(require("./clamp-text.scss"));
var ClampText = /** @class */ (function (_super) {
    tslib_1.__extends(ClampText, _super);
    function ClampText(props) {
        var _this = _super.call(this, props) || this;
        _this.clamp = function () {
            var clampOptions = _this.props.clampOptions;
            if (clampOptions.disabled || _this.isUsingCSSClamp) {
                return;
            }
            if (_this.title) {
                (0, text_overflow_clamp_1.default)(_this.title, clampOptions);
            }
        };
        _this.saveRef = function (ref) {
            _this.title = ref;
        };
        var isServer = typeof document === 'undefined';
        _this.isUsingCSSClamp =
            isServer ||
                (feature_detector_1.default.isMultilineClampAvailable() && !props.enforceJSClamp);
        return _this;
    }
    ClampText.prototype.componentDidMount = function () {
        (0, lodash_1.defer)(this.clamp);
    };
    ClampText.prototype.componentDidUpdate = function () {
        this.clamp();
    };
    ClampText.prototype.render = function () {
        var _a;
        var _b = this.props, text = _b.text, dataHook = _b.dataHook, clampOptions = _b.clampOptions, wrapperTag = _b.wrapperTag, className = _b.className;
        var useCss = !clampOptions.disabled && this.isUsingCSSClamp;
        var props = {
            ref: this.saveRef,
            className: (0, classnames_1.default)(clamp_text_scss_1.default.text, (_a = {},
                _a[clamp_text_scss_1.default.lineClamp] = useCss,
                _a), className),
            'data-hook': dataHook,
            title: text,
            style: {
                WebkitLineClamp: useCss ? clampOptions.lineClamp : undefined,
            },
        };
        return react_1.default.createElement(wrapperTag, props, text);
    };
    ClampText.defaultProps = {
        clampOptions: {
            lineClamp: 2,
            disabled: false,
        },
        wrapperTag: 'div',
        enforceJSClamp: false,
    };
    return ClampText;
}(react_1.default.PureComponent));
exports.default = ClampText;
//# sourceMappingURL=clamp-text.js.map